import { adminInfo } from './adminInfo';
import { BaseClass } from './base_class';
import { BaseInterface } from './base_interface';
export class RealSeason extends BaseClass implements BaseInterface {

constructor() {
    super();
    this.id = 0;
    this.description = "";
    this.season_startDate = "";
    this.season_endDate = "";
    this.controls = {
        id: "string",
        description: "string",
        season_startDate: "string",
        season_endDate: "string",

    }
}

controls: any = {
    id: "number",
    description: "string",
    season_startDate: "string",
    season_endDate: "string",
}

id: number;
description: string;
season_startDate: string;
season_endDate: string;

}

export class RealSeasonResponse {
    payload: RealSeason;
    admin_info: adminInfo;
}
